import React from 'react';

function SourceBoxDescription({ content }) {
  if (!content) { return null; }

  return (
    <p>{ content }</p>
  )
}

export default SourceBoxDescription;



// WEBPACK FOOTER //
// ./src/components/SourceBox/SourceBoxDescription.js